import axios from 'axios';

const BASE = '/api/lead-automation';

const leadAutomationService = {
  get: async () => (await axios.get(BASE)).data.settings,
  update: async settings => (
    await axios.put(BASE, settings)
  ).data.settings,
  runs: async () => (
    await axios.get(`${BASE}/runs`)
  ).data.runs,
  dashboard: async filters => (
    await axios.get(`${BASE}/dashboard`, { params: filters })
  ).data,
  simulateCommercialPlaybook: async payload => (await axios.post('/api/commercial-playbook/simulate', payload)).data,
  getCommercialPlaybook: async () => (
    await axios.get('/api/commercial-playbook')
  ).data,
  updateCommercialPlaybook: async playbook => (
    await axios.put('/api/commercial-playbook', playbook)
  ).data.playbook,
};

export default leadAutomationService;
